






























  import { v4 } from 'uuid';
  import { ValidationProvider } from 'vee-validate';
  import Vue from 'vue';

  const VALIDATION_MODE_EAGER = 'eager';
  const COLONNES_CHAMP_VUETIFY = '11';
  export default Vue.extend({
    name: 'ChampFormulaire',
    components: {
      ValidationProvider,
    },
    props: {
      alignementColonneDroite: {
        type: String,
        default: 'center',
      },
      colonnesChamp: {
        type: String,
        default: COLONNES_CHAMP_VUETIFY,
      },
      immediate: {
        type: Boolean,
        default: false,
      },
      nom: {
        type: String,
        default: '',
      },
      modeValidation: {
        type: String,
        default: VALIDATION_MODE_EAGER,
      },
      validation: {
        type: [String, Object],
        default: '',
      },
    },
    data: () => ({
      vid: v4(),
    }),
  });
